import './App.css';
import Tempapp from './components/Tempapp';
function App() {
  return (
    <Tempapp></Tempapp>
  );
  
  
  
}
export default App;
